import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import { ToastProvider } from 'react-toast-notifications';

ReactDOM.render(
  // @ts-ignore
  <ToastProvider autoDismiss autoDismissTimeout={4000} placement="top-center">
    <Root />
  </ToastProvider>,
  document.getElementById('root')
);
